/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */
import React, {useState} from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button} from '@mui/material';
import CreateCategoryDialog from "../dialogs/CreateCategoryDialog";

const CategoryTable = ({ categories, ssp, ssc}) => {
    const [Opencreatecategorydialog, setOpencreatecategorydialog] = useState(false)
    return (
        <div >

        <h1>Категории</h1>
            <CreateCategoryDialog open={Opencreatecategorydialog} setOpen={setOpencreatecategorydialog}/>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>АЙДИ</TableCell>
                        <TableCell>ЗАГОЛОВОК</TableCell>
                        <TableCell>ИКОНКА</TableCell>
                        <TableCell>ПРОДУКТЫ</TableCell>
                        <TableCell><Button onClick={()=>{setOpencreatecategorydialog(true)}} >ДОБАВИТЬ</Button></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {categories.map((category) => (
                        <TableRow key={category.id}>
                            <TableCell>{category.id}</TableCell>
                            <TableCell>{category.title}</TableCell>
                            <TableCell>
                                <img src={`http://localhost:8083/photo/JPEG/${category.icon}`} alt={category.title} width={50} height={50} />
                            </TableCell>
                            <TableCell><Button variant='contained' onClick={()=>{
                                ssp(category.products)
                                ssc(category.id)
                            }}>Продукты</Button></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        </div>
    );
};
export default CategoryTable